module.exports = __webpack_public_path__ + "img/272I5525.8cdca0d4.jpeg";